// import RequestError from '../Errors/RequestError.js'
// import CONFIG from '../config'
import Response from './response'
import http from './http-common'

import RequestError from '../Errors/RequestError.js'

export default class Request {
    constructor(config) {
        this.config = config
    }

    /**
     * @returns {Promise}
     */
    send() {
        return new Promise((resolve, reject) => {
            http.request(this.config)
                .then(response => {
                    resolve(new Response(response))
                })
                .catch(error => {
                    // console.log('Error', error)
                    reject(
                        new RequestError(error, new Response(error.response))
                    )
                })
        })
    }
}
